module.exports = __webpack_public_path__ + "img/tip-bg.84a0bf09.png";